// extracted by css-extract-rspack-plugin
export default {"BetaLabel":"IntegerField-module__BetaLabel__RgE7F"};